import type { FC } from 'react';
import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import { Box, Container, Typography } from '@material-ui/core';

export const ComingSoon: FC = () => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      my: 10
    }}
  >
    <Container
      maxWidth="md"
      sx={{
        px: 5,
        py: 10,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <DeveloperModeIcon sx={{ color: 'text.secondary' }} />
      <Typography
        align="center"
        color="textPrimary"
        sx={{ my: 2 }}
        variant="h3"
      >
        Coming Soon!
      </Typography>
      <Typography
        align="center"
        color="textSecondary"
        variant="body2"
      >
        Under Development
      </Typography>
    </Container>
  </Box>
);
